import { Site } from "./site.model";
import { Slot } from "./slot.model";
import { Hold } from "./hold.model";

export class Session {
  startDate: string;
  endDate: string;
  selectedDate?: string;
  groupId?: number;
  site?: Site;
  availabilities?: any[];
  sessionId?: number;
  duration?: any;
  startDateTime?: string;
  endDateTime?: string;
  defaultMonth?: string;
  selectedRangeStartDate?: any;
  selectedRangeEndDate?: any;
  maxDays?: number;
  confirmationNumber?: string;
  selected?: boolean;
  disabled?: boolean;
  slot?: Slot;
  hold?: Hold;
  appointmentId?: string;
  canReschedulePolicy?: any;

  getEligibleMonth(sessionStart: Date) {
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1)
    //return tomorrow if no start date
    if (!sessionStart) {
      return tomorrow.getFullYear().toString() + "-" + (tomorrow.getMonth() + 1).toString();
    }

    // set start to start date that was passed in or tomorrow, whichever is later
    let startDate = new Date(sessionStart);
    if (startDate < tomorrow) {
      startDate = tomorrow;
    }

    return startDate.getFullYear().toString() + "-" + (startDate.getMonth() + 1).toString();
  }

  constructor();
  constructor(startDate: string,
    endDate: string,
    site?: Site,
    availabilities?: any[],
    selected?: boolean,
    duration?: any,
    confirmationNumber?: string,
  );
  constructor(
    startDate?: string,
    endDate?: string,
    site?: Site,
    availabilities?: any[],
    selected?: boolean,
    duration?: any,
    confirmationNumber?: string,
    selectedDate?: string,
    sessionId?: number,
    groupId?: number,
    startDateTime?: string,
    endDateTime?: string,
  );
  constructor(
    startDate?: string,
    endDate?: string,
    site?: Site,
    availabilities?: any[],
    selected?: boolean,
    duration?: any,
    confirmationNumber?: string,
    selectedDate?: string,
    sessionId?: number,
    groupId?: number,
    startDateTime?: string,
    endDateTime?: string,
    selectedRangeStartDate?: any,
    selectedRangeEndDate?: any,
    maxDays?: number,
    disabled?: boolean,
    slot?: Slot,
    hold?: Hold,
    appointmentId?: string,
  )

  constructor(
    startDate?: string,
    endDate?: string,
    site?: Site,
    availabilities?: any[],
    selected?: boolean,
    duration?: any,
    confirmationNumber?: string,
    selectedDate?: string,
    sessionId?: number,
    groupId?: number,
    startDateTime?: string,
    endDateTime?: string,
    selectedRangeStartDate?: any,
    selectedRangeEndDate?: any,
    maxDays?: number,
    disabled?: boolean,
    slot?: Slot,
    hold?: Hold,
    appointmentId?: string,
  ) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.selectedDate = selectedDate;
    this.groupId = groupId;
    this.site = site;
    this.availabilities = availabilities;
    this.sessionId = sessionId;
    this.duration = duration;
    this.startDateTime = startDateTime;
    this.endDateTime = endDateTime;
    this.selected = selected;
    this.confirmationNumber = confirmationNumber;
    this.defaultMonth = this.getEligibleMonth(new Date(startDate));
    this.selectedRangeStartDate = selectedRangeStartDate;
    this.selectedRangeEndDate = selectedRangeEndDate;
    this.maxDays = maxDays;
    this.disabled = disabled;
    this.slot = slot;
    this.hold = hold;
    this.appointmentId = appointmentId;
  }

}